import { render, staticRenderFns } from "./SystemForm.vue?vue&type=template&id=0bd75f07&scoped=true&"
import script from "./SystemForm.vue?vue&type=script&lang=js&"
export * from "./SystemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd75f07",
  null
  
)

export default component.exports